import { SchemaClient } from "../../../common/GraphqlClient";
import { EMPTY_VALUE, FieldValues, Schema } from "../../../Schema";
import { getEntry, getAndProcessEntry } from "../../common/external-sources/Entry";

/**
 * Cluster getters. A cluster is the same GraphQL type as an equipment
 * (`DigitalLabInstrumentRepositoryEntry`); the difference is the schema, which
 * additionally selects the `subEquipment` connection (see the cluster
 * `subEquipments` field's `graphql.selection`). Selection mechanics live in
 * `Entry.ts`.
 */

/** Fetches a cluster entry by id and returns the raw GraphQL record. */
export const getCluster = async (
  client: SchemaClient,
  schema: Schema,
  id: string
): Promise<FieldValues | typeof EMPTY_VALUE> => {
  return await getEntry(client, schema, id);
};

/** Fetches a cluster entry by id and maps it into form values (`FROM_GRAPHQL`). */
export const getAndProcessCluster = async (
  client: SchemaClient,
  schema: Schema,
  id: string
): Promise<FieldValues> => {
  return await getAndProcessEntry(client, schema, id);
};
